





















import {Vue, Component, Prop, PropSync, Watch} from 'vue-property-decorator';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import {SelectListItem} from '@/types/claim';

@Component({
  components: {
    CompSelectBox
  }
})
export default class MemberGroupSelect extends Vue{
  private memberGroupSelectList: SelectListItem[] = []

  @Prop({required: true})
  private readonly mallNo!: undefined | number;
  @PropSync('memberGroupNo')
  private memberGroupNoSync!: undefined | number;

  @Watch('mallNo')
  async fetchAndSetMemberGroups(){
    if(!this.mallNo){
      this.memberGroupSelectList = []
      return
    }

    const {data: memberGroups} = await this.$api.getMemberGroups({params: {mallNo: this.mallNo}})
    this.memberGroupSelectList = memberGroups.map(memberGroup => ({
      name: memberGroup.name,
      value: memberGroup.no
    }))
  }
}
